import axios from "./axios";

export default {
    getImageInBase64(data) {
        const options = {
            method: 'POST',
            url: `utilities/getImageInBase64`,
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },


    async getRescueUrl(keymaster) {
        try {
            const url = process.env.VUE_APP_RESCUE_BACKEND_URL + `/getRescueUrl?keyMaster=${keymaster}`;
            
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            console.log('rescue data')
            console.log(data)
            
            return data;
        } catch (error) {
            console.error('Ping failed:', error);
            
            // handle ping failure (backend offline) here
            
            return false;
        }
    },

    async ping(url) {
        try {
            console.log('PING BACKEND')

             let pingBackend = ''

            if (url.endsWith('/api')) {
                pingBackend = url.replace('/api', '')
            } else if (url.endsWith('/api/')) {
                pingBackend = url.replace('/api/', '')
            }
            
            console.log('Ping URL:', pingBackend);
            const response = await fetch(pingBackend);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            
            return true;
        } catch (error) {
            console.error('Ping failed:', error);
            
            // handle ping failure (backend offline) here
            
            return false;
        }
    }
}